import React from 'react';
import styles from './qualificationsAndResponsibilities.module.scss';
import { Col, Row, Button, Badge } from 'react-bootstrap';
import { Form as ReactForm } from "react-bootstrap"
import { CustomButton } from '../../../../shared/customButton';
import { CustomDraggbleTextField } from '../../../../shared/customDraggbleTextField';
import { CustomTextField } from '../../../../shared/customTextField'
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import ReactTooltip from 'react-tooltip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export const QualificationsAndResponsibilities = (props) => {

    const initialValues = {
        qualifications: props.pipelineValues.qualifications,
        responsibilities: props.pipelineValues.responsibilities
    };



    const validationSchema = Yup.object().shape({
        qualifications: Yup.array().of(
            Yup.object().shape({
                qualification: Yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required')
            })
        ),
        responsibilities: Yup.array().of(
            Yup.object().shape({
                responsibility: Yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required')
            })
        ),


    });

    //on submit function
    const onSubmit = async (values) => {
        props.setQualificationsAndResponsibilities(values);
        props.nextPage(4)
    }

    const addQalificationField = (e, values, setValues) => {

        const qualifications = [...values.qualifications];

        let newQualification = {
            qualification: ''
        }

        qualifications.push(newQualification);
        setValues({ ...values, qualifications });

    }

    const addResponsibilityField = (e, values, setValues) => {

        const responsibilities = [...values.responsibilities];

        let newResponsibility = {
            responsibility: ''
        }

        responsibilities.push(newResponsibility);
        setValues({ ...values, responsibilities });

    }

    const removeQalificationField = (e, id, values, setValues) => {
        const qualifications = [...values.qualifications];
        if (qualifications.length !== 0) {
            let newArray = qualifications.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, qualifications: newArray });
        }
    }

    const removeResponsibilityField = (e, id, values, setValues) => {
        const responsibilities = [...values.responsibilities];
        if (responsibilities.length !== 0) {
            let newArray = responsibilities.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, responsibilities: newArray });
        }
    }


    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => onSubmit(values)}
            >

                {({
                    errors,
                    values,
                    handleChange,
                    touched,
                    setValues,
                    handleSubmit,
                    submitCount,
                    setFieldValue,
                }) => (
                    <Form>
                        <div>
                            <p className={styles.subTopics}>Qualifications</p>
                            <FieldArray name="qualifications">
                                {(arrayHelpers) => {
                                    const handleOnDragEnd = (result) => {
                                        if (!result.destination) {
                                            return;
                                        }

                                        const { source, destination } = result;

                                        arrayHelpers.move(source.index, destination.index);
                                    };

                                    return (
                                        <DragDropContext onDragEnd={handleOnDragEnd}>
                                            <Droppable droppableId="qualifications">
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        <>
                                                            {values.qualifications && values.qualifications.map((qualification, i) => {
                                                                const qualificationErrors = (errors.qualifications?.length && errors.qualifications[i]) || {};
                                                                const qualificationTouched = (touched.qualifications?.length && touched.qualifications[i]) || {};
                                                                return (
                                                                    <Draggable key={i} draggableId={`customQuestion-${i}`} index={i}>
                                                                        {(provided) => (
                                                                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                <CustomDraggbleTextField
                                                                                    keyValue={i}
                                                                                    classLabel="defaultLabel"
                                                                                    placeholder="Enter a description..."
                                                                                    controlId={`qualifications.${i}`}
                                                                                    type="text"
                                                                                    value={(values && values.qualifications && values.qualifications[i]) && values.qualifications[i].qualification}
                                                                                    handleOnChange={handleChange}
                                                                                    name={`qualifications.${i}.qualification`}
                                                                                    classType="defaultTextBox"
                                                                                    onCancelClick={(e) => removeQalificationField(e, i, values, setValues)}
                                                                                    errorMessage={(errors && errors.qualifications && errors.qualifications[i]) && errors.qualifications[i].qualification}
                                                                                    isInvalid={qualificationErrors.qualification && qualificationTouched.qualification}
                                                                                    isCancelable={true}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                );
                                                            })}
                                                            {provided.placeholder}
                                                        </>
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    );
                                }}
                            </FieldArray>
                            <CustomButton
                                id="add_qualification"
                                buttonType="button"
                                label="Add Qualification"
                                type="secondarySmallBtn"
                                handleClick={(e) => addQalificationField(e, values, setValues)}
                                frontIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                }

                            />
                        </div>

                        <div className={styles.responsibilitiesDiv}>
                            <p className={styles.subTopics}>Responsibilities</p>
                            <FieldArray name="responsibilities">
                                {(arrayHelpers) => {
                                    const handleOnDragEnd = (result) => {
                                        if (!result.destination) {
                                            return;
                                        }

                                        const { source, destination } = result;

                                        arrayHelpers.move(source.index, destination.index);
                                    };

                                    return (
                                        <DragDropContext onDragEnd={handleOnDragEnd}>
                                            <Droppable droppableId="responsibilities">
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        <>
                                                            {values.responsibilities && values.responsibilities.map((responsibility, i) => {
                                                                const responsibilityErrors = (errors.responsibilities?.length && errors.responsibilities[i]) || {};
                                                                const responsibilityTouched = (touched.responsibilities?.length && touched.responsibilities[i]) || {};
                                                                return (
                                                                    <Draggable key={i} draggableId={`responsibilities-${i}`} index={i}>
                                                                        {(provided) => (
                                                                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                <CustomDraggbleTextField
                                                                                    keyValue={i}
                                                                                    classLabel="defaultLabel"
                                                                                    placeholder="Enter a description..."
                                                                                    controlId={`responsibilities.${i}`}
                                                                                    type="text"
                                                                                    value={(values && values.responsibilities && values.responsibilities[i]) && values.responsibilities[i].responsibility}
                                                                                    handleOnChange={handleChange}
                                                                                    name={`responsibilities.${i}.responsibility`}
                                                                                    classType="defaultTextBox"
                                                                                    onCancelClick={(e) => removeResponsibilityField(e, i, values, setValues)}
                                                                                    errorMessage={(errors && errors.responsibilities && errors.responsibilities[i]) && errors.responsibilities[i].responsibility}
                                                                                    isInvalid={responsibilityErrors.responsibility && responsibilityTouched.responsibility}
                                                                                    isCancelable={true}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                );
                                                            })}
                                                            {provided.placeholder}
                                                        </>
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    );
                                }}
                            </FieldArray>

                            <CustomButton
                                id="add_responsibilities"
                                buttonType="button"
                                label="Add Responsibilities"
                                type="secondarySmallBtn"
                                handleClick={(e) => addResponsibilityField(e, values, setValues)}
                                frontIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                }

                            />
                        </div>

                        <hr className={styles.dividerLine}/>
                        <Row className="mt-3 mb-3 d-flex flex-row-reverse">
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_qualification_confirm"
                                    buttonType="submit"
                                    label="Next"
                                    type="primaryBtn"
                                />
                            </div>
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_qualification_cancel"
                                    buttonType="button"
                                    label="Back"
                                    type="defaultBtn"
                                    handleClick={() => props.previousPage(2)}

                                />
                            </div>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    )
}
